/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_CharterInputs */

const es_nav_m_charter = /** @type {(inputs: Nav_M_CharterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

const gl_nav_m_charter = /** @type {(inputs: Nav_M_CharterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

const en_nav_m_charter = /** @type {(inputs: Nav_M_CharterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

/**
* | output |
* | --- |
* | "Charter" |
*
* @param {Nav_M_CharterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_charter = /** @type {((inputs?: Nav_M_CharterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_CharterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_charter(inputs)
	if (locale === "en") return en_nav_m_charter(inputs)
	return es_nav_m_charter(inputs)
});